/* ============================================================================
   DTF Studio — print files (hand-written; NOT generated). window.DTFPrint
   • renderPNG: the gang sheet as a transparent RGBA PNG at 300 DPI, any length. The sheet is drawn in
     horizontal strips and streamed through the browser's native zlib (CompressionStream), so a 22×240 in
     sheet (6600×72000 px) never needs a canvas bigger than 6600×256. Images are drawn from the customer's
     ORIGINAL files (full resolution), text/clipart are re-rendered as vectors at print size.
   • buildPDF: the same sheet as a PDF (pdf-lib): each distinct image embedded once at ≤300 DPI of its
     largest placed size and drawn with its exact transform; text/clipart rasterised at 300 DPI.
     Pages longer than 200 in use /UserUnit (PDF 1.6) so readers accept them.
   Objects are Fabric objects in WORLD units (wpi units per inch); (ox, oy) = the sheet's top-left in world units.
   Not mirrored — the RIP mirrors for DTF.
   ========================================================================== */
(function () {
  'use strict';
  var CRC = (function () { var t = new Uint32Array(256); for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; } return t; })();
  function crc32(buf, crc) { crc = (crc === undefined ? 0xFFFFFFFF : crc); for (var i = 0; i < buf.length; i++) crc = CRC[(crc ^ buf[i]) & 0xFF] ^ (crc >>> 8); return crc; }
  function u32(v) { return new Uint8Array([(v >>> 24) & 255, (v >>> 16) & 255, (v >>> 8) & 255, v & 255]); }
  function chunk(type, data) {
    var t = new Uint8Array([type.charCodeAt(0), type.charCodeAt(1), type.charCodeAt(2), type.charCodeAt(3)]);
    var c = crc32(data, crc32(t)) ^ 0xFFFFFFFF;
    return [u32(data.length), t, data, u32(c >>> 0)];
  }
  function sleep0() { return new Promise(function (r) { setTimeout(r, 0); }); }
  // always a DOM canvas: Fabric's text renderer reads ctx.canvas.getAttribute('dir'), which OffscreenCanvas lacks
  function mkCanvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function mul(a, b) { return [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3], a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]]; }
  function hasCompression() { return typeof CompressionStream !== 'undefined'; }
  async function deflate(bytes) {
    var cs = new CompressionStream('deflate'), w = cs.writable.getWriter();
    w.write(bytes); w.close();
    return new Uint8Array(await new Response(cs.readable).arrayBuffer());
  }

  // world bounding box of a Fabric object (no viewport)
  function textPad(o) {
    var p = 0;
    (function walk(x, sc) { var s2 = sc * Math.max(Math.abs(x.scaleX || 1), Math.abs(x.scaleY || 1)); if (/text/.test(x.type)) p = Math.max(p, (x.fontSize || 0) * s2 * 0.6 + (x.strokeWidth || 0) * s2); if (x._objects) x._objects.forEach(function (c) { walk(c, s2); }); })(o, 1);
    return p;
  }
  function wbox(o) {
    var m = o.calcTransformMatrix(), d = o._getNonTransformedDimensions ? o._getNonTransformedDimensions() : { x: o.width, y: o.height }, w = d.x / 2, h = d.y / 2, l = Infinity, t = Infinity, r = -Infinity, b = -Infinity;
    [[-w, -h], [w, -h], [w, h], [-w, h]].forEach(function (p) { var x = m[0] * p[0] + m[2] * p[1] + m[4], y = m[1] * p[0] + m[3] * p[1] + m[5]; l = Math.min(l, x); t = Math.min(t, y); r = Math.max(r, x); b = Math.max(b, y); });
    var pad = textPad(o);
    return { l: l - pad, t: t - pad, r: r + pad, b: b + pad };
  }

  function noCache() { this.ownCaching = false; return false; }
  // draw one object into ctx whose base transform maps world → output pixels (k px per world unit, origin ox/oy, strip y0)
  function drawObject(ctx, o, k, ox, oy, y0, src) {
    var M = o.calcTransformMatrix();
    ctx.save();
    ctx.setTransform(k * M[0], k * M[1], k * M[2], k * M[3], k * (M[4] - ox), k * (M[5] - oy) - y0);
    ctx.globalAlpha = o.opacity == null ? 1 : o.opacity;
    if (o.type === 'image') {
      var el = o.getElement(), pw = el.naturalWidth || el.width, w = o.width, h = o.height;
      var s = src || el, sw = s.naturalWidth || s.width, r = pw ? sw / pw : 1;
      var cx = (o.cropX || 0) * r, cy = (o.cropY || 0) * r;
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(s, cx, cy, Math.min(w * r, sw - cx), Math.min(h * r, (s.naturalHeight || s.height) - cy), -w / 2, -h / 2, w, h);
    } else {
      // vectors: text, clipart, shapes, groups — re-rendered at output resolution. Caching is switched off on the
      // object AND every child: a group's children would otherwise paint their small on-screen cache bitmaps.
      var saved = [];
      (function off(x) {
        saved.push([x, x.objectCaching, Object.prototype.hasOwnProperty.call(x, 'shouldCache') ? x.shouldCache : undefined]);
        x.objectCaching = false; if (!x.clipPath) x.shouldCache = noCache;
        if (x._objects) x._objects.forEach(off);
      })(o);
      // a group's children add the group's own transform unless the group says it is already applied (Group.render
      // sets _transformDone; drawing the group directly must too, or rotated/moved groups print twice-transformed)
      var td = o._transformDone; o._transformDone = true;
      try { o.drawObject(ctx); } finally { o._transformDone = td; saved.forEach(function (p) { p[0].objectCaching = p[1]; if (p[2] === undefined) delete p[0].shouldCache; else p[0].shouldCache = p[2]; }); }
    }
    ctx.restore();
  }

  /* renderPNG(opt) → Blob (image/png, 300 DPI)
     opt: { widthIn, lengthIn, dpi=300, wpi, ox, oy, objects, source(o) → Promise<drawable|null> (full-res),
            keyOf(o) → string, onProgress(fraction, text), stripRows=256, trim (cut the file at the lowest design) } */
  async function renderPNG(opt) {
    if (!hasCompression()) throw new Error('This browser cannot stream a print file (no CompressionStream). Use Chrome, Edge, Firefox or Safari 16.4+.');
    var dpi = opt.dpi || 300, k = dpi / opt.wpi, W = Math.round(opt.widthIn * dpi);
    var objs = opt.objects.filter(function (o) { return o.visible !== false; }).map(function (o, z) { return { o: o, bx: wbox(o), z: z }; }), fallback = {};
    var lenIn = opt.lengthIn;
    if (opt.trim && objs.length) { var lo = 0; objs.forEach(function (x) { lo = Math.max(lo, x.bx.b); }); lenIn = Math.min(lenIn, Math.ceil(((lo - opt.oy) / opt.wpi + 0.25) * 4) / 4); }
    var H = Math.round(lenIn * dpi), SR = opt.stripRows || 256;
    objs.sort(function (a, b) { return a.bx.t - b.bx.t; });
    // full-res sources, decoded once, released as soon as the strips have passed their last use
    var lastUse = {}, cache = {};
    objs.forEach(function (x) { if (x.o.type === 'image') { var kk = opt.keyOf(x.o); lastUse[kk] = Math.max(lastUse[kk] || 0, x.bx.b); } });
    function get(o) {
      var kk = opt.keyOf(o);
      if (!cache[kk]) cache[kk] = Promise.resolve(opt.source ? opt.source(o) : null).catch(function () { return null; }).then(function (b) { if (!b) fallback[kk] = 1; return b; });
      return cache[kk];
    }
    var parts = [new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10])];
    function push(arr) { arr.forEach(function (p) { parts.push(p); }); }
    var ih = new Uint8Array(13); ih.set(u32(W), 0); ih.set(u32(H), 4); ih[8] = 8; ih[9] = 6; ih[10] = 0; ih[11] = 0; ih[12] = 0;
    push(chunk('IHDR', ih));
    var ppm = Math.round(dpi / 0.0254), ph = new Uint8Array(9); ph.set(u32(ppm), 0); ph.set(u32(ppm), 4); ph[8] = 1;
    push(chunk('pHYs', ph));
    var soft = new TextEncoder().encode('Software\0StickerMint DTF Studio');
    push(chunk('tEXt', soft));
    // zlib stream of filtered scanlines → IDAT chunks
    var cs = new CompressionStream('deflate'), writer = cs.writable.getWriter(), reader = cs.readable.getReader();
    var pend = [], pendLen = 0;
    function flush(force) {
      if (!pendLen || (!force && pendLen < 1 << 20)) return;
      var d = new Uint8Array(pendLen), o = 0; pend.forEach(function (p) { d.set(p, o); o += p.length; });
      push(chunk('IDAT', d)); pend = []; pendLen = 0;
    }
    var pump = (async function () { for (;;) { var r = await reader.read(); if (r.done) break; pend.push(r.value); pendLen += r.value.length; flush(false); } })();
    // the browser skips a text run whose line box (ascent to descent) misses the canvas, so ink a font paints above or
    // below it (bold italics, accents, outlines) was cut off at a strip edge: strips with text get OV rows of room above
    // and below (up to the object's text pad), drawn but never read
    var tp = function (o) { return o.type === 'image' ? 0 : Math.min(512, Math.ceil(textPad(o) * k)); }, OV = 0;
    objs.forEach(function (x) { OV = Math.max(OV, tp(x.o)); });
    var cv = mkCanvas(W, SR + 2 * OV), ctx = cv.getContext('2d', { willReadFrequently: true });
    var rowB = W * 4, prev = new Uint8Array(rowB), idx = 0;
    for (var y0 = 0; y0 < H; y0 += SR) {
      var h = Math.min(SR, H - y0);
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, OV, W, SR);
      var wy0 = opt.oy + y0 / k, wy1 = opt.oy + (y0 + h) / k;
      while (idx < objs.length && objs[idx].bx.b < wy0) idx++;
      var hits = [];
      for (var i = idx; i < objs.length && objs[i].bx.t <= wy1; i++) if (objs[i].bx.b >= wy0) hits.push(objs[i]);
      hits.sort(function (a, b) { return a.z - b.z; });
      var ov = 0; hits.forEach(function (x) { ov = Math.max(ov, tp(x.o)); });
      if (OV) { ctx.save(); ctx.beginPath(); ctx.rect(0, OV - ov, W, SR + 2 * ov); ctx.clip(); } // image-only strips stay SR rows
      for (var hI = 0; hI < hits.length; hI++) {
        var x = hits[hI], src = x.o.type === 'image' ? await get(x.o) : null;
        drawObject(ctx, x.o, k, opt.ox, opt.oy, y0 - OV, src);
      }
      if (OV) ctx.restore();
      // release sources nobody below needs
      Object.keys(cache).forEach(function (kk) { if (lastUse[kk] < wy0) { cache[kk].then(function (b) { if (b && b.close) b.close(); }); delete cache[kk]; } });
      var data = ctx.getImageData(0, OV, W, h).data, out = new Uint8Array(h * (rowB + 1));
      for (var r = 0; r < h; r++) {
        var so = r * rowB, oo = r * (rowB + 1);
        out[oo] = 2; // "Up" filter: transparent film and flat art compress to almost nothing
        for (var j = 0; j < rowB; j++) out[oo + 1 + j] = (data[so + j] - prev[j]) & 255;
        prev = data.subarray(so, so + rowB);
      }
      prev = new Uint8Array(prev);
      await writer.ready; writer.write(out);
      if (opt.onProgress) opt.onProgress(Math.min(1, (y0 + h) / H), 'Rendering ' + Math.round((y0 + h) / dpi) + ' of ' + Math.round(H / dpi) + ' in');
      await sleep0();
    }
    await writer.close(); await pump; flush(true);
    push(chunk('IEND', new Uint8Array(0)));
    Object.keys(cache).forEach(function (kk) { cache[kk].then(function (b) { if (b && b.close) b.close(); }); });
    return { blob: new Blob(parts, { type: 'image/png' }), widthPx: W, heightPx: H, lengthIn: lenIn, fallback: Object.keys(fallback) };
  }

  // quick raster of the sheet (previews / thumbnails) from the on-screen images
  function drawSheet(ctx, objects, k, ox, oy) {
    objects.forEach(function (o) { if (o.visible !== false) drawObject(ctx, o, k, ox, oy, 0, null); });
  }

  // ── PDF ───────────────────────────────────────────────────────────────────
  // the painted extent of a vector object (world units), from a ~1000 px copy of its padded box, plus a small margin
  function inkBox(o, bx) {
    var W = bx.r - bx.l, H = bx.b - bx.t, k = Math.min(8, 1000 / Math.max(W, H, 1));
    var cw = Math.max(1, Math.ceil(W * k)), ch = Math.max(1, Math.ceil(H * k)), cv = mkCanvas(cw, ch), x = cv.getContext('2d', { willReadFrequently: true });
    try { drawObject(x, o, k, bx.l, bx.t, 0, null); } catch (e) { cv.width = cv.height = 1; return bx; }
    var d = x.getImageData(0, 0, cw, ch).data, x0 = cw, y0 = ch, x1 = -1, y1 = -1;
    for (var y = 0, i = 3; y < ch; y++) for (var xx = 0; xx < cw; xx++, i += 4) if (d[i]) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    cv.width = cv.height = 1;
    if (x1 < 0) return bx;
    var m = 2 / k + 0.5; // two small-copy pixels + a little, so anti-aliased edges are never clipped
    return { l: Math.max(bx.l, bx.l + x0 / k - m), t: Math.max(bx.t, bx.t + y0 / k - m), r: Math.min(bx.r, bx.l + (x1 + 1) / k + m), b: Math.min(bx.b, bx.t + (y1 + 1) / k + m) };
  }
  async function rawImage(doc, drawable, w, h, forceAlpha) {
    var L = window.PDFLib, N = L.PDFName, ctx0 = doc.context;
    var own = !(drawable.getContext && drawable.width === w && drawable.height === h), cv = own ? mkCanvas(w, h) : drawable, x = cv.getContext('2d', { willReadFrequently: true });
    if (own) { x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; x.drawImage(drawable, 0, 0, w, h); }
    var d = x.getImageData(0, 0, w, h).data, n = w * h, alpha = !!forceAlpha;
    if (!alpha) for (var i = 3; i < d.length; i += 4) if (d[i] < 255) { alpha = true; break; }
    var ref;
    if (!alpha && (cv.convertToBlob || cv.toBlob)) {
      var jb = cv.convertToBlob ? await cv.convertToBlob({ type: 'image/jpeg', quality: 0.92 }) : await new Promise(function (r) { cv.toBlob(r, 'image/jpeg', 0.92); });
      var jpg = new Uint8Array(await jb.arrayBuffer());
      ref = ctx0.register(L.PDFRawStream.of(ctx0.obj({ Type: 'XObject', Subtype: 'Image', Width: w, Height: h, ColorSpace: 'DeviceRGB', BitsPerComponent: 8, Filter: 'DCTDecode', Length: jpg.length }), jpg));
    } else {
      // PNG "Up" row predictor (Predictor 15, one filter byte per row): transparent film and flat art compress several
      // times smaller than raw rows, so long, busy sheets stay under the upload cap at 300 DPI
      var W4 = w * 4, rb = w * 3 + 1, ab = w + 1, fr = new Uint8Array(h * rb), fa = new Uint8Array(h * ab);
      for (var y = 0; y < h; y++) {
        var s = y * W4, e = s + W4, o3 = y * rb, o1 = y * ab, q;
        fr[o3++] = 2; fa[o1++] = 2;
        if (y) { for (q = s; q < e; q += 4) { fr[o3++] = (d[q] - d[q - W4]) & 255; fr[o3++] = (d[q + 1] - d[q + 1 - W4]) & 255; fr[o3++] = (d[q + 2] - d[q + 2 - W4]) & 255; fa[o1++] = (d[q + 3] - d[q + 3 - W4]) & 255; } }
        else { for (q = s; q < e; q += 4) { fr[o3++] = d[q]; fr[o3++] = d[q + 1]; fr[o3++] = d[q + 2]; fa[o1++] = d[q + 3]; } }
      }
      var zr = await deflate(fr); fr = null;
      var za = await deflate(fa); fa = null;
      var sm = ctx0.register(L.PDFRawStream.of(ctx0.obj({ Type: 'XObject', Subtype: 'Image', Width: w, Height: h, ColorSpace: 'DeviceGray', BitsPerComponent: 8, Filter: 'FlateDecode', DecodeParms: ctx0.obj({ Predictor: 15, Colors: 1, BitsPerComponent: 8, Columns: w }), Length: za.length }), za));
      ref = ctx0.register(L.PDFRawStream.of(ctx0.obj({ Type: 'XObject', Subtype: 'Image', Width: w, Height: h, ColorSpace: 'DeviceRGB', BitsPerComponent: 8, Filter: 'FlateDecode', DecodeParms: ctx0.obj({ Predictor: 15, Colors: 3, BitsPerComponent: 8, Columns: w }), SMask: sm, Length: zr.length }), zr));
    }
    cv.width = cv.height = 1;
    return ref;
  }
  /* buildPDF(opt) → Uint8Array
     opt: { widthIn, lengthIn, wpi, ox, oy, objects, source(o) → Promise<drawable|null>, keyOf(o), maxDpi=300, title, onProgress } */
  async function buildPDF(opt) {
    var L = window.PDFLib; if (!L) throw new Error('pdf-lib missing');
    if (!hasCompression()) throw new Error('no CompressionStream');
    var maxDpi = opt.maxDpi || 300, wpi = opt.wpi;
    var doc = await L.PDFDocument.create(), ptW = opt.widthIn * 72, ptH = opt.lengthIn * 72, uu = ptH > 14400 ? Math.ceil(ptH / 14400) : 1;
    var page = doc.addPage([ptW / uu, ptH / uu]);
    if (uu > 1) page.node.set(L.PDFName.of('UserUnit'), L.PDFNumber.of(uu));
    var s = 72 / (wpi * uu), PH = ptH / uu, F = [s, 0, 0, -s, -opt.ox * s, PH + opt.oy * s];
    var objs = opt.objects.filter(function (o) { return o.visible !== false; });
    // one embedded image per source + crop, at the resolution its largest placement needs (never above maxDpi)
    var groups = {}, order = [];
    objs.forEach(function (o) {
      if (o.type !== 'image' || (o.opacity != null && o.opacity < 1)) return;
      var kk = opt.keyOf(o) + '|' + [o.cropX || 0, o.cropY || 0, o.width, o.height].map(function (v) { return Math.round(v); }).join(',');
      var inW = o.width * Math.abs(o.scaleX) / wpi, inH = o.height * Math.abs(o.scaleY) / wpi;
      if (!groups[kk]) { groups[kk] = { o: o, inW: 0, inH: 0, uses: [] }; order.push(kk); }
      var g = groups[kk]; g.inW = Math.max(g.inW, inW); g.inH = Math.max(g.inH, inH); g.uses.push(o);
    });
    var ops = [], done = 0, total = order.length + objs.length, names = new Map(), fallback = {};
    function prog(t) { done++; if (opt.onProgress) opt.onProgress(done / total, t); }
    for (var gi = 0; gi < order.length; gi++) {
      var g = groups[order[gi]], o = g.o, el = o.getElement(), pw = el.naturalWidth || el.width;
      var got = await Promise.resolve(opt.source ? opt.source(o) : null).catch(function () { return null; });
      if (!got) fallback[opt.keyOf(o)] = 1;
      var src = got || el;
      var sw = src.naturalWidth || src.width, r = pw ? sw / pw : 1;
      var sh0 = src.naturalHeight || src.height, cw = Math.max(1, Math.min(sw - (o.cropX || 0) * r, Math.round(o.width * r))), ch = Math.max(1, Math.min(sh0 - (o.cropY || 0) * r, Math.round(o.height * r)));
      var need = Math.max(g.inW, g.inH) * maxDpi, have = Math.max(cw, ch), f = have > need * 1.02 ? need / have : 1;
      var w = Math.max(1, Math.round(cw * f)), h = Math.max(1, Math.round(ch * f));
      var crop = mkCanvas(w, h), cx = crop.getContext('2d');
      cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high';
      cx.drawImage(src, (o.cropX || 0) * r, (o.cropY || 0) * r, cw, ch, 0, 0, w, h);
      var ref = await rawImage(doc, crop, w, h);
      crop.width = crop.height = 1;
      if (src.close && src !== el) src.close();
      var name = page.node.newXObject('Im', ref);
      g.uses.forEach(function (u) { names.set(u, name); });
      prog('Embedding images');
      await sleep0();
    }
    // draw in canvas (stacking) order: images by reference, everything else rasterised at maxDpi at its box
    for (var i = 0; i < objs.length; i++) {
      var ob = objs[i], nmI = names.get(ob);
      if (nmI) {
        var M = ob.calcTransformMatrix(), uw = ob.width, uh = ob.height, T = mul(F, mul(M, [uw, 0, 0, -uh, -uw / 2, uh / 2]));
        ops.push(L.pushGraphicsState(), L.concatTransformationMatrix(T[0], T[1], T[2], T[3], T[4], T[5]), L.drawObject(nmI), L.popGraphicsState());
        continue;
      }
      var bx = inkBox(ob, wbox(ob)), k = maxDpi / wpi, pw2 = Math.max(1, Math.ceil((bx.r - bx.l) * k)), ph2 = Math.max(1, Math.ceil((bx.b - bx.t) * k));
      var cv = mkCanvas(pw2, ph2), c2 = cv.getContext('2d');
      var srcI = null;
      if (ob.type === 'image') { srcI = await Promise.resolve(opt.source ? opt.source(ob) : null).catch(function () { return null; }); if (!srcI) fallback[opt.keyOf(ob)] = 1; }
      drawObject(c2, ob, k, bx.l, bx.t, 0, srcI);
      var ref2 = await rawImage(doc, cv, pw2, ph2, true);
      cv.width = cv.height = 1;
      var nm = page.node.newXObject('Vx', ref2);
      var X = (bx.l - opt.ox) * s, Y = PH - (bx.b - opt.oy) * s;
      ops.push(L.pushGraphicsState(), L.concatTransformationMatrix((bx.r - bx.l) * s, 0, 0, (bx.b - bx.t) * s, X, Y), L.drawObject(nm), L.popGraphicsState());
      prog('Rendering text and shapes');
    }
    page.pushOperators.apply(page, ops);
    doc.setTitle(opt.title || ('DTF gang sheet ' + opt.widthIn + 'x' + opt.lengthIn + ' in'));
    doc.setProducer('StickerMint DTF Studio'); doc.setCreator('StickerMint DTF Studio');
    var bytes = await doc.save({ useObjectStreams: false });
    bytes.fallback = Object.keys(fallback);
    bytes.userUnit = uu; // > 1: the page is written at 1/uu size with /UserUnit uu (readers that ignore it show it smaller)
    return bytes;
  }

  // textPad(o): world units of ink a text object (or a group holding text) can paint outside its Fabric box (accents,
  // swashes, outline); wbox(o): its world box grown by that pad; drawObject(ctx, o, k, ox, oy, y0, src) renders one
  // object exactly as the print does; buildPDF's bytes.userUnit tells the caller the page's /UserUnit (1 = none)
  window.DTFPrint = { renderPNG: renderPNG, buildPDF: buildPDF, drawSheet: drawSheet, drawObject: drawObject, textPad: textPad, wbox: wbox, crc32: crc32, _mul: mul };
})();
